import { render, staticRenderFns } from "./flow-service-table.vue?vue&type=template&id=77157713&scoped=true"
import script from "./flow-service-table.vue?vue&type=script&lang=js"
export * from "./flow-service-table.vue?vue&type=script&lang=js"
import style0 from "./flow-service-table.vue?vue&type=style&index=0&id=77157713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77157713",
  null
  
)

export default component.exports